import { PaymentType } from "src/api";
import { usePaymentValidation } from "src/hooks";
import { _t } from "src/utils/translation";

interface UseWithdrawalValidationParams {
  amount: string;
  paymentFeeError: string | null;
  paymentFee?: number;
  /** Remaining limit-group headroom (wallet currency); Infinity = no cap. */
  availableLimit?: number;
}

export interface WithdrawalErrors {
  inputErrors: string[];
  paymentFeeErrors: string[];
  paymentValidationErrors: string[];
}

export const useWithdrawalValidation = (params: UseWithdrawalValidationParams) => {
  const { amount, paymentFeeError, paymentFee, availableLimit } = params;

  const { paymentValidationErrors } = usePaymentValidation({
    amount: Number(amount),
    paymentType: PaymentType.Withdrawal,
    fee: paymentFee,
    availableLimit,
  });

  const errors: WithdrawalErrors = {
    inputErrors: [
      ...(!amount ? [_t("VALIDATION.AMOUNT_SHOULD_NOT_BE_EMPTY")] : []),
      ...(Number(amount) <= 0 ? [_t("VALIDATION.AMOUNT_SHOULD_BE_GREATER_THAN_ZERO")] : []),
    ],
    paymentFeeErrors: paymentFeeError ? [_t("VALIDATION.ERROR_ESTIMATING_PAYMENT_FEE")] : [],
    paymentValidationErrors: paymentValidationErrors,
  };

  return {
    errors,
  };
};
